<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Consumable/In/'">
          <el-button type="primary" size="mini">物品入库登记</el-button>
        </router-link>
      </div>

      <label class="label-name">所属公司：</label>
      <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <label style="margin-left:10px;" class="label-name">搜索：</label>
      <el-input style="display:inline-block;width:300px;" v-model="filterKey" size="small"
        placeholder="你可以搜索入库人员/所属部门/入库单号等"></el-input>

    </div>

    <!-- <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="form.type">
        <el-radio-button label="0">审核中</el-radio-button>
        <el-radio-button label="1">已审核通过/取消/删除</el-radio-button>
      </el-radio-group>
    </div> -->

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column label="入库单号" width="100px">
        <template slot-scope="scope">
          <a href="javascript:void(0)" @click="ShowMaterialInDetail(scope.row)">{{ scope.row.number }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="supplier.name" label="供应商">
      </el-table-column>
      <el-table-column prop="inVoice" label="发票号码" width="100px">
      </el-table-column>
      <el-table-column label="入库操作员" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="ghTime" label="供货时间" width="130px">
      </el-table-column>
      <el-table-column prop="total" label="总金额(元)" width="80">
      </el-table-column>

      <!-- <el-table-column label="审批状态" width="100">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)" type="primary">详情</el-button>

          <el-tooltip class="item" effect="dark" content="修改物品申购单" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"
              @click="getRouterLink(scope.row.id)"></i>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <consumable-in-detail v-on:hideDetail="hideDetail()" :detailStatus="detailStatus" :consumableInData="consumableInData">
    </consumable-in-detail>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import projectInfo from '@/page/user/projectInfo'
  import approvalType from '@/Mixins/approvalType'

  import UserInfo from '@/components/UserInfo'
  // import CancelFlow from '@/components/CancelFlow'
  import Role from '@/Mixins/role'
  import ApprovalStatus from '@/components/ApprovalStatus'

  import consumableInDetail from './components/InDetail'
  export default {
    components: {
      UserInfo,
      // CancelFlow,
      projectInfo,
      ApprovalStatus,
      consumableInDetail,
    },
    mixins: [approvalType, Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 是否可切换公司
        noSelectOrganization: false,
        houseList: "",

        organizationListData: [],

        form: {
          depId: '',
          type: 0
        },
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        // filter
        filterKey: "",


        // 入库单明细详情
        detailStatus: false,
        consumableInData: "",
      }
    },
    created() {
      // this.organizationListData.push({
      //   id: 0,
      //   name: "集团所有公司",
      //   depId: 0
      // })

      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.form.depId == "7" || this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
        // this.form.depId = 0
      }
    },
    mounted() {},
    methods: {
      // 编辑的链接生成
      getRouterLink(applyId) {
        this.$router.push({
          path: '/Consumable/In',
          query: {
            applyId: applyId,
          }
        })
      },

      hideDetail() {
        this.detailStatus = false
      },
      // 显示入库单详情
      projectDetail(row) {

        this.consumableInData = row
        this.detailStatus = true
        // console.log(row)
        // let _projectTable = {
        //   status: true,
        //   applyId: row.flow.applyId,
        //   // 62: 易耗品入库
        //   tableType: '62',
        // }
        // this.$store.commit('set_projectTable', _projectTable)
      },
      getDateByTime(time) {
        // return time
        return window.util.getFormatDate(time, true)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        // console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            if (_item.flow.creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || (_item
                .type && _item.type
                .toLowerCase()
                .indexOf(this.filterKey.toLowerCase()) != -1)) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.filterKey = ""
        this.loading = true
        let _url = '/consumable/in/list'

        ajax.get(_url, {
          'depId': this.form.depId == 0 ? "" : this.form.depId,
          'type': this.form.type
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'form.depId'() {
        this.getLists()
      },
      'form.type'() {
        this.getLists()
      },
      filterKey() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/consumable/InList.vue